import React from "react";
const SuccessBookingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={181} height={123} fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#F5E7F8"
        d="m150.592 57.717 4.766 36.52c1.152 8.825-5.16 16.922-14.1 18.087l-83.723 10.928c-8.946 1.157-17.117-5.043-18.27-13.868L34.5 72.864a15.894 15.894 0 0 1 .965-7.882 16.342 16.342 0 0 1 13.14-10.199l83.73-10.913a16.36 16.36 0 0 1 15.324 6.489 15.897 15.897 0 0 1 2.934 7.358Z"
      />
      <path
        fill="#F5E7F8"
        d="m145.256 51.81-10.862 9.232-35.163 29.896a4.09 4.09 0 0 1-5.733.747L48.141 69.473l-9.27-4.54a4.086 4.086 0 0 1-.747-5.73l7.418-9.638 13.977-18.16 22.009-28.59a4.083 4.083 0 0 1 5.732-.747l28.607 21.993L131.1 35.77l13.412 10.31a4.091 4.091 0 0 1 .744 5.729Z"
      />
      <path
        fill="#3E4957"
        d="M145.726 52.258 99.69 91.389a4.74 4.74 0 0 1-6.547.857l-54.63-26.754-.043-.048a4.736 4.736 0 0 1-.865-6.633L81.007 2.424a4.73 4.73 0 0 1 6.64-.867l57.253 44.01a4.742 4.742 0 0 1 .865 6.638l-.039.053ZM98.757 90.487l46.036-39.132a3.442 3.442 0 0 0-.67-4.774L86.873 2.566a3.442 3.442 0 0 0-4.828.63L38.64 59.584a3.445 3.445 0 0 0 .582 4.788l54.622 26.75.043.048c.61.474 1.363.725 2.135.713a3.426 3.426 0 0 0 2.694-1.343l.04-.054Z"
      />
      <path
        fill="#fff"
        d="m129.665 24.81 4.728 36.233L99.23 90.94a4.09 4.09 0 0 1-5.733.747L48.14 69.474l-4.367-33.463a2.528 2.528 0 0 1 2.185-2.836l80.861-10.546a2.533 2.533 0 0 1 2.846 2.18Z"
      />
      <path
        fill="#3E4957"
        d="m135.065 61.3-.254.232-35.117 29.85a4.725 4.725 0 0 1-6.527.848L47.56 69.895l-4.411-33.8a3.167 3.167 0 0 1 2.739-3.534L126.743 22a3.162 3.162 0 0 1 3.547 2.725l4.775 36.576Zm-36.3 29.196.05-.045 34.906-29.669-4.685-35.894a1.885 1.885 0 0 0-.725-1.26 1.897 1.897 0 0 0-1.404-.375l-80.87 10.544a1.902 1.902 0 0 0-1.64 2.128l4.322 33.127 45.108 22.09.043.048a3.454 3.454 0 0 0 4.847-.632l.049-.062Z"
      />
      <path
        fill="#3E4957"
        d="M123.959 37.338a.547.547 0 0 1-.305.14L52.397 46.77a.565.565 0 0 1-.146-1.12l71.257-9.286a.563.563 0 0 1 .456.98l-.005-.005ZM125.479 48.98a.574.574 0 0 1-.307.142L53.915 58.41a.563.563 0 0 1-.146-1.115l71.257-9.29a.564.564 0 0 1 .456.98l-.003-.004ZM126.997 60.62a.548.548 0 0 1-.304.141l-71.25 9.3a.565.565 0 0 1-.145-1.12l71.257-9.286a.563.563 0 0 1 .456.98l-.014-.015Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h180v123H.5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SuccessBookingIcon;
